<template>
  <textarea
    :maxlength="maxlength"
    :name="name"
    :placeholder="placeholder"
    :value="value"
    :rows="rows"
    :disabled="disabled"
    class="c-textarea"
    @focusout="focusout"
    @input="input"
    ref="textarea"
  ></textarea>
</template>

<script>
export default {
  props: {
    autosize: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    maxlength: {
      type: [Number, String],
      required: false
    },
    name: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: '入力してください'
    },
    rows: {
      type: Number,
      required: false
    },
    trim: {
      type: Boolean,
      required: false
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      height: {
        max: null,
        min: null
      },
      offset: 0
    };
  },
  watch: {
    height: {
      handler() {
        if (this.autosize) {
          this.setHeight();
        }
      },
      deep: true
    },
    value: {
      handler() {
        if (this.autosize) {
          this.setHeight();
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.autosize) {
      this.getStyle();
      window.addEventListener('resize', this.getStyle);
    }
  },
  beforeDestroy() {
    if (this.autosize) {
      window.removeEventListener('resize', this.getStyle);
    }
  },
  methods: {
    focusout(e) {
      let value = e.target.value;
      value = value.trim();
      this.$emit('input', value);
      this.$emit('focusout', e);
    },
    getStyle() {
      const style = window.getComputedStyle(this.$refs.textarea, null);
      const maxHeight = parseFloat(style.maxHeight);
      const minHeight = parseFloat(style.minHeight);
      this.height.max = Math.max(maxHeight, minHeight);
      this.height.min = Math.min(maxHeight, minHeight);
      this.offset =
        parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    },
    input(e) {
      let value = e.target.value;
      if (this.trim) {
        value = value.trim();
      }
      this.$emit('input', value);
    },
    setHeight() {
      this.$nextTick(() => {
        let el = this.$refs.textarea;
        el.style.height = 'auto';
        el.style.overflowY = 'hidden';

        let height = el.scrollHeight + this.offset;
        if (height > this.height.max) {
          height = this.height.max;
          el.style.overflowY = 'scroll';
        } else if (height < this.height.min) {
          height = this.height.min;
        }
        el.style.height = height + 'px';

        // カーソル位置がテキスト末尾の場合は最下部までスクロールする
        // （文字をいっぱい入れるとスクロール位置が若干ずれて気持ち悪いので）
        if (this.value.length === el.selectionStart) {
          el.scrollTop = el.scrollHeight;
        }
      });
    }
  }
};
</script>
